import React from 'react';
import { MediaTypeEnum } from 'api';
import useStyles from './imgCrop.styles';
import 'react-image-crop/dist/ReactCrop.css';
import { EnhancedButton } from 'components/EnhancedButton';
import ReactCrop, { Crop, PixelCrop } from 'react-image-crop';
import { Aspect, useImageUploader } from './hooks/useImageUploader';
import { StyledDropzone } from 'components/StyledDropZone/StyledDropZone';
import { Button, Container, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const ImageUploader: React.FC<Props> = ({ open, onClose }: Props) => {
  const classes = useStyles();
  const vm = useImageUploader();

  return (
    <Dialog
      open={open}
      maxWidth="lg"
      onClose={onClose}
      disableBackdropClick
      classes={{
        scrollPaper: classes.topScrollPaper,
        paperScrollBody: classes.topPaperScrollBody
      }}
    >
      <DialogTitle>Upload image</DialogTitle>

      <DialogContent className={classes.content} dividers>
        {Boolean(vm.imgSrc) ? (
          <Container maxWidth="lg" className={classes.container}>
            <Container className={classes.ratios}>
              <Button
                size="small"
                color="primary"
                variant="outlined"
                onClick={() => {
                  vm.setAspectRatio(1.91);
                  vm.setAspect(Aspect.MARKETING_IMAGE);
                }}
              >
                1.91X1
              </Button>

              <Button
                size="small"
                color="primary"
                variant="outlined"
                onClick={() => {
                  vm.setAspectRatio(1);
                  vm.setAspect(Aspect.SQUARE_MARKETING_IMAGE);
                }}
              >
                1X1
              </Button>
              {!vm.isDisplayCampaign && (
                <Button
                  size="small"
                  color="primary"
                  variant="outlined"
                  onClick={() => {
                    vm.setAspectRatio(4 / 5);
                    vm.setAspect(Aspect.PORTRAIT_MARKETING_IMAGE);
                  }}
                >
                  4X5
                </Button>
              )}
            </Container>

            <ReactCrop
              ruleOfThirds
              src={vm.imgSrc}
              crop={vm.crop as Crop}
              className={classes.img}
              onImageLoaded={vm.onImageLoad}
              onChange={(newCrop) => vm.setCrop({ ...newCrop, aspect: vm.aspectRatio })}
              onComplete={(c) => vm.setCompletedCrop({ ...c, aspect: vm.aspectRatio } as PixelCrop)}
            />
          </Container>
        ) : (
          <StyledDropzone onSelectFile={vm.onSelectFile} mediaType={MediaTypeEnum.IMAGE} multiple={false} />
        )}
      </DialogContent>

      <DialogActions>
        <Button
          size="small"
          variant="text"
          color="primary"
          disabled={vm.loading}
          onClick={vm.resetSelection}
          style={{ marginRight: 'auto' }}
        >
          Choose different image
        </Button>

        <Button disabled={vm.loading} variant="text" color="primary" size="small" onClick={onClose}>
          Cancel
        </Button>

        <EnhancedButton
          size="small"
          variant="contained"
          color="primary"
          loading={vm.loading}
          disabled={!vm.imgSrc}
          onClick={async () => {
            const blob = await vm.getImg();
            await vm.handleImageUpload(blob);
          }}
        >
          Upload
        </EnhancedButton>
      </DialogActions>
    </Dialog>
  );
};
